import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Button, Modal } from 'antd';
import FormImports from './FormImports';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';
import constants from '../../config/api/constants';

const ModalImportItem = ({
  title = 'importListItems',
  downloadRoute = constants.customListImportTemplate,
  downloadText = 'downloadBaseTemplate',
  modalWidth = '70%',
  show,
  handleClose,
  importList,
  showSaveButton,
  onUploadItems,
  renderItems,
  closeOnUpload = true,
}) => {
  const { translate: t } = useDictionaryTranslation();

  const { idAcount } = useSelector((state) => {
    return {
      idAcount: state.auth.accountData._id,
    };
  });

  const handleClosseModal = (successImport) => {
    handleClose({ successImport });
  };

  const uploadImportList = useCallback(
    async (file) => {
      let successImport = false;
      try {
        await importList({ file, idAcount });
        successImport = true;
      } catch (error) {
        console.error(error);
      }
      if (!showSaveButton && closeOnUpload) {
        handleClosseModal(successImport);
      }
      return successImport;
    },
    [importList, idAcount, closeOnUpload, handleClosseModal, showSaveButton],
  );

  const onUpload = () => {
    onUploadItems();
  };

  return (
    <>
      <Modal
        maskClosable={false}
        title={t(title)}
        centered
        width={modalWidth}
        height="80%"
        onCancel={() => handleClosseModal(false)}
        destroyOnClose
        open={show}
        footer={
          showSaveButton ? (
            <Button type="primary" onClick={onUpload}>
              {t('send')}
            </Button>
          ) : null
        }
      >
        <FormImports downloadRoute={downloadRoute} downloadText={downloadText} uploadImportList={uploadImportList} />

        {renderItems?.()}
      </Modal>
    </>
  );
};

ModalImportItem.propTypes = {
  title: PropTypes.string,
  downloadRoute: PropTypes.string,
  downloadText: PropTypes.string,
  modalWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  importList: PropTypes.func,
  showSaveButton: PropTypes.bool,
  onUploadItems: PropTypes.func,
  renderItems: PropTypes.func,
  closeOnUpload: PropTypes.bool,
};

export default ModalImportItem;
